import React, { Profiler, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
//Components
// import LandingPage from './components/_index';

//API 
//context 
import UserContext from "./context/UserContext";
//CSS

import './app.scss';
import './index.scss';
import KioskMainEcommers from "./layouts/Kiosk_ecommers_stant/KioskMainEcommers.jsx";
import BranchofficeSelect from "./components/Branch/BranchofficeSelect.jsx";
import BranchSelectNew from "./components/Branch/BranchSelectNew.jsx";
//Icons
import 'bootstrap-icons/font/bootstrap-icons.css'
import { Home } from "./components/Home/Home.jsx";

import { Menu } from "./components/Menu/Menu.jsx";
import { Cupons } from "./components/Cupons/Cupons.jsx";
import { Orders } from "./components/Orders/Orders.jsx";
import { Notifications } from "./components/Notifications/Notifications.jsx";
import { Profile } from "./components/Profile/Profile.jsx";
//import { Profile } from "./components/Profile/Profile.jsx";
import { ShoppingCart } from "./components/ShoppingCart/ShoppingCart.jsx";
import { Checkout } from "./components/ShoppingCart/components/Checkout.jsx";

import OrderConfirmation from "./components/ShoppingCart/OrderConfirmation.jsx";
import OrderPending from "./components/ShoppingCart/OrderPending.jsx";
import OrderToAprove from "./components/ShoppingCart/OrderToApprove.jsx";
import TilopayResult from "./components/Tilopay/TilopayResult.jsx";
import OrderQuote from "./components/Orders/OrdersQuote.jsx";
//context
import { ProductProvider, ProductContext } from "./context/ProductContext.jsx";
import { BranchofficesByEventProvider } from "./context/BranchofficesByEventContext.jsx";
import { TableSessionProvider } from "./context/TableSessionContext.jsx";

import NoMatch from "./components/common/layout/NoMatch.jsx";
import Contact from "./components/Contact/Contact.jsx";
import About from "./components/About/About.jsx";
import ScrollToTop from "./utils/ScrollToTop .jsx";
import Product from "./components/Product/Product.jsx";
import TableEntryPage from "./components/Table/TableEntryPage.jsx";
import TablePrepayEntryPage from "./components/Table/TablePrepayEntryPage.jsx";
import TableSessionJoinPage from "./components/Table/TableSessionJoinPage.jsx";

import Invoice from './documents/Invoice';
import { AUTH_INVALID_EVENT, CONTEXT_INVALID_EVENT } from "./utils/ownershipContext";
import {
  TABLE_SESSION_INVALID_EVENT,
  TABLE_SESSION_ORDER_FINISHED_EVENT,
} from "./context/TableSessionContext";

// Hard circuit breaker for the whole redirect-on-error mechanism below. No matter WHICH endpoint
// keeps 401/404ing (a cross-origin cookie that never gets stored - always the case in Incognito/
// InPrivate - can make many different "public" calls fail at once), every failure funnels through
// onAuthInvalid/onContextInvalid and calls navigate() here. Without a cap, that becomes an infinite
// bounce between /profile, /home and /branch* - this counts redirects in a short rolling window and
// simply stops navigating (the alert still shows once) once too many happen too fast, regardless of
// which specific request is the culprit this time.
const REDIRECT_GUARD_KEY = "ownershipRedirectGuardV1";
const REDIRECT_GUARD_WINDOW_MS = 8000;
const REDIRECT_GUARD_MAX = 4;

const shouldAllowOwnershipRedirect = () => {
  let guard;
  try {
    guard = JSON.parse(sessionStorage.getItem(REDIRECT_GUARD_KEY) || "null");
  } catch (err) {
    guard = null;
  }

  const now = Date.now();
  if (!guard || now - guard.firstAt > REDIRECT_GUARD_WINDOW_MS) {
    guard = { firstAt: now, count: 0 };
  }

  guard.count += 1;
  try {
    sessionStorage.setItem(REDIRECT_GUARD_KEY, JSON.stringify(guard));
  } catch (err) {
    // ignore - worst case the guard just doesn't persist across this one event
  }

  return guard.count <= REDIRECT_GUARD_MAX;
};

function OwnershipHttpEvents() {
  const navigate = useNavigate();

  useEffect(() => {
    // The client session is already cleared by the axios interceptor before this fires
    // (clearClientSession()); we don't force-navigate away from wherever the user is —
    // the page just re-renders in its logged-out state, with the alert already shown.
    const onAuthInvalid = () => {
      if (!shouldAllowOwnershipRedirect()) return;
      navigate("/profile");
     };

    const onContextInvalid = (event) => {
      if (!shouldAllowOwnershipRedirect()) return;

      if (event?.detail?.scope === "business") {
        navigate("/home");
        return;
      }

      navigate("/branch/select/true");
    };

    // A collaborative table-session call came back 401 (dead/expired participant cookie) -
    // TableSessionContext already cleared its own local state, this just moves the person
    // somewhere safe instead of leaving them on a screen for a session that no longer exists.
    const onTableSessionInvalid = () => {
      navigate("/menu");
    };

    const onTableSessionOrderFinished = (event) => {
      const orderCode = event?.detail?.orderCode;
      if (orderCode) navigate(`/order/${encodeURIComponent(orderCode)}`);
    };

    window.addEventListener(AUTH_INVALID_EVENT, onAuthInvalid);
    window.addEventListener(CONTEXT_INVALID_EVENT, onContextInvalid);
    window.addEventListener(TABLE_SESSION_INVALID_EVENT, onTableSessionInvalid);
    window.addEventListener(TABLE_SESSION_ORDER_FINISHED_EVENT, onTableSessionOrderFinished);

    return () => {
      window.removeEventListener(AUTH_INVALID_EVENT, onAuthInvalid);
      window.removeEventListener(CONTEXT_INVALID_EVENT, onContextInvalid);
      window.removeEventListener(TABLE_SESSION_INVALID_EVENT, onTableSessionInvalid);
      window.removeEventListener(TABLE_SESSION_ORDER_FINISHED_EVENT, onTableSessionOrderFinished);
    };
  }, [navigate]);

  return null;
}

function App() {
  const [userData, setUserData] = useState({
    token: undefined,
    user: undefined
  });


  return (
    <Router>
      <UserContext.Provider value={{ userData, setUserData }}>
        <BranchofficesByEventProvider>
          <ProductProvider>
            <TableSessionProvider>
              <OwnershipHttpEvents />
              <ScrollToTop />
              <Routes>
              {/* Index Main Menu  */}
              <Route path="/" element={<Home />} />
              {/* Ecommerce */}
              <Route path="/home" element={<Home />} />
              <Route path="/home/:profile" element={<Home />} />
              <Route path="/home/quote/:order_code" element={<Home />} />
              <Route path="/cupons" element={<Cupons />} />
              <Route path="/branch" element={<BranchSelectNew />} />
              <Route path="/branch/select/:type" element={<BranchSelectNew />} />
              <Route path="/branch/quote/:order_code" element={<BranchSelectNew />} />
              <Route path="/branch/:profile" element={<BranchSelectNew />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/table/:publicTableCode" element={<TableEntryPage />} />
              <Route path="/table/prepay/:token" element={<TablePrepayEntryPage />} />
              <Route path="/table/join/:token" element={<TableSessionJoinPage />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/cart" element={<ShoppingCart />} />
           
              <Route path="/cart/order/:quote/:code/:PreOrder_id" element={<ShoppingCart />} />
              <Route path="/cart/product/:keyproduct" element={<ShoppingCart />} />
              <Route path="/cart/order/:code/:PreOrder_id" element={<ShoppingCart />} /> 
              
              <Route path="/order/:order_code" element={<OrderConfirmation />} />
              <Route path="/pending/order/:order_code" element={<OrderPending />} />
              <Route path="/order/pending/:order_code" element={<OrderToAprove />} />
              <Route path="/tilopay/result" element={<TilopayResult />} />
              <Route path="/order/quote/:order_code" element={<OrderQuote />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/product" element={<Product />} />
              <Route path="/kiosk/ecommers/stant/:business_code/:branchoffice_code/:machine_code_table" element={<KioskMainEcommers />} />
              <Route path="/kiosk/ecommers/branchshoffices/:business_code" element={<BranchofficeSelect />}></Route>
              {/* No Match link */}
              <Route path="*" element={<NoMatch />} />

              <Route path="/pdf" element={<Invoice />} />
              </Routes>
            </TableSessionProvider>
          </ProductProvider>
        </BranchofficesByEventProvider>
      </UserContext.Provider>
    </Router>
  );
}

export default App;
